export function animateFingerPress(timeline, finger, when=0) {
    let fingerGraphic = $(finger).find('.finger-graphic')[0];
    let tapCircle = $(finger).find('.tap-circle')[0];

    timeline.add({
        targets: fingerGraphic,
        scale: 0.7,
        duration: 200
    }, when);

    // Circle animation (appear, scale, and fade out)
    timeline.add({
        targets: tapCircle,
        scale: [0, 3],
        opacity: [1, 0],
        duration: 500,
        easing: 'easeInOutQuad'
    }, when);
}

export function  animateFingerRelease(timeline, finger, when=0) {
    let fingerGraphic = $(finger).find('.finger-graphic')[0];

    timeline.add({
        targets: fingerGraphic,
        scale: 1,
        duration: 200
    }, when);
}
